<template>
    <div class="strategic__contain">
        <div class="banner">11</div>
    </div>
</template>

<script>
    import icon_stra from '@/assets/img/strabanner.png'
    export default {
        name: 'Test',
        data (){
            return {
                icon_stra
            }
        },
        components: {
        }
    }
</script>
<style  lang="scss" scoped>
    .strategic__contain
    {
        .banner{
            width: 100%;
            img{
                width: 100%;
                display: block;
            }
        }
    }
</style>
